<template>
  <div class="billing-page">
    <div :class="isPublicRoute() == true ? 'adjustment billing centered':'billing'">
          
          <LoadingIndicator v-if="loading && !error"
          class="centered-message"
          message="Getting Vocation Packages"/>
          <SystemMessage v-if="!loading && error"
          class="centered-message"
          message="Unable to get Vocation Packages. Please try refreshing the page."/>

        <div v-if="!loading && !error && hasExpired" class="expired">
          {{ pagecontent.subscription.renew }}
        </div>

        <div class="card-list">
          <div v-if="!loading && !error" v-for="offer in vocationPackages" class="package theme-card">
            <div class="card-header">
              <div class="card-header-content">
                <div class="package-name">
                  {{offer.name}}
                </div>
                <div class="price">
                  <div class="figure">{{offer.currency}} {{formatNumber(offer.price)}}</div>
                  <div class="per">{{offer.period}}</div>
                </div>
            </div>

            </div>
            <div class="features" :style="!isAuthenticated && hasErrors == false ? 'min-height:10rem!important;':''">
              
              <div class="feature-items">
                  <div v-for="feature in offer.features" class="feature-info">
                    {{feature}}
                  </div>
                
              </div>
            </div>
            <button v-if="isAuthenticated && offer?.isValidRole && hasErrors == false" class="btn btn-default purchase" :disabled="buttonClickIsLoading" @click="offer.clickFunction()">{{ buttonClickIsLoading == true ? 'Redirecting...':'Pay' }}</button>
            
            <div class="description" v-if="!isAuthenticated && hasErrors == false">{{ offer.description }}</div>
              <!-- errors -->
            <div class="errors" v-if="isAuthenticated && offer?.isValidRole && hasErrors">
                <div class="error" v-for="error in errors">{{ error }}</div>
            </div>
            <!-- errors -->  
          </div>  
        </div>

        <div  v-if="!loading && !error" class="notice" v-html="pagecontent.subscription.paymentNote"></div>
          <VerifyPayment v-if="isPendingSessionAvailable" class="verify"/>
    </div>
    <ContactInformation v-if="!loading && !error && isPublicRoute() == true"/>
  </div>
  <CustomConfirmationMessageModal ref="paymentErrorModal"
            :close-modal="() => closeModal()"
            :title="modal.title"
            :body="modal.body"
            :button-label="modal.buttonLabel"
            :modal-id="modal.modalId"/>

</template>
<script>
  import PageHeader from '@/components/Utility/PageHeader.vue';
  import CheckmarkIcon from '@/components/IconComponents/CheckmarkIcon.vue';
  import LoadingIndicator from '@/components/Utility/LoadingIndicator.vue';
  import SystemMessage from '@/components/Utility/SystemMessage.vue';
  import { getPackagesAsync, payForEmployer, payForJobSeeker} from '@/services/billing/billingService';
  import pagecontent from '@/assets/text.json'
  import CustomConfirmationMessageModal from '@/components/modals/CustomConfirmationMessageModal.vue';
  import VerifyPayment from './AccountSettings/VerifyPayment.vue';
  import ContactInformation from '@/components/ContactInformation.vue';
  export default{
    components:{
      PageHeader,
       CheckmarkIcon,
       LoadingIndicator,
       SystemMessage,
       CustomConfirmationMessageModal,
       VerifyPayment,
       ContactInformation
    },
    computed:{
      isAuthenticated(){
        return this.$store.getters['auth/isAuthenticated']
      },
      
    },
    data(){
      return{
        loading: true,
        error: false,
        vocationPackages: [],
        pagecontent,
        hasExpired:false,
        modal:{
          title:"",
          body:"",
          buttonLabel:"Close",
          modalId:"paymentModal"
        },
        buttonClickIsLoading: false,
        errors:[],
        hasErrors:false,
        isPendingSessionAvailable: false
      }

    },
    mounted(){   
    window.scrollTo({top: 0,behavior: 'smooth'});
    if(this.$route.query.hasExpired != null){
      this.hasExpired = true;
    }else{
      this.hasExpired = false
    }
      setTimeout(async() => await this.getPackages(), 2000);
    },
    methods:{
        isPublicRoute(){
            return this.$route.name == 'billing' ? true : false
        },
      async getPackages(){
        try{
          let response = await getPackagesAsync();
          if(!response.success){
                this.loading = false;
                this.error =  true;
          }else{
            this.loading = false;
            this.error = false;
            this.vocationPackages = response.packages;
            this.vocationPackages[0].clickFunction = () => this.startJobSeekerPayment();
            this.vocationPackages[1].clickFunction = () => this.startEmployerPayment();
            
            let _authUser = localStorage.getItem('user');
            if(_authUser != null){
              let user = JSON.parse(_authUser);

              if(Array.isArray(user.roles)){
                this.vocationPackages[0].isValidRole = user.roles.some(role => this.vocationPackages[0].roles.includes(role));
                this.vocationPackages[1].isValidRole = user.roles.some(role => this.vocationPackages[1].roles.includes(role));
              }
            }

            this.isPendingSessionAvailable = response.isPendingSessionAvailable;
            
          }
        }catch(e){
          this.loading = false;
          this.error =  true;
        }
      },
       formatNumber(value) {
        return new Intl.NumberFormat().format(value);
      },
      async startJobSeekerPayment(){
        try{
            this.errors = [];
            this.hasErrors = false;
            this.buttonClickIsLoading = true;
            var response = await payForJobSeeker();
            this.buttonClickIsLoading = false;
            if(response.success){
              if(response.transactionDetails){
                window.location.href = response.transactionDetails.checkoutUrl
              }
            }else{
              let err = new Error(response.message);
              err.reason = response.caption;
              throw err;
            }
          }catch(e){
          let message = e.message || "Something went wrong. Unable to commence payment session.";
          // this.loading = false;
          this.buttonClickIsLoading = false;
          this.errors.push(message);
          this.hasErrors = true;
          setTimeout(() => this.resetButton(), 2000);
          }
      },
      async startEmployerPayment(){
        try{
          this.errors = [];
          this.hasErrors = false;
          this.buttonClickIsLoading = true;
          var response = await payForEmployer();
          this.buttonClickIsLoading = false;
          if(response.success){
            if(response.transactionDetails){
              window.location.href = response.transactionDetails.checkoutUrl
            }
          }else{
             let err = new Error(response.message);
              err.reason = response.caption;
              throw err;
          }
        }catch(e){
          let message = e.message || "Something went wrong. Unable to commence payment session.";
          // this.loading = false;
          this.buttonClickIsLoading = false;
          this.errors.push(message);
          this.hasErrors = true;
          setTimeout(() => this.resetButton(), 2000);
        }
      },
      showModal(){
        this.$refs.paymentErrorModal.show();
      },
      closeModal(){
        this.$refs.paymentErrorModal.hide();
      },
      resetButton(){
        this.loading = false;
        this.errors = [];
        this.hasErrors = false;
      }
    }
}
</script>
<style scoped>

  .verify{
    grid-column: 1/3;
    grid-row:4/5;
  }

  .small-link{
    text-decoration: none;
    color:var(--page-header);
  }

  .billing{
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto auto auto;
    row-gap:1rem;
    
  }

  .expired{
    grid-column: 1/3;
    grid-row:1/2;
    background: var(--expired);
    margin-left: 1rem;
    margin-right: 1rem;
    margin-top: 1rem;
    padding:1rem;
    border-radius:20px;
    font-family: var( --heading-font2-regular);
  }

  

  .notice{
    grid-column: 1/3;
    grid-row:3/4;
    background: var(--intro-background);
    padding:1rem;
    border-radius: 12px;
    font-size:0.7rem;
    line-height:1.2rem;
     /* font-family: var(--page-header-font); */


  }

  .description{
     font-size:0.7rem;
    line-height:1.2rem;
    text-align: center;
    font-family: var(--page-header-font);
  }

  .card-list{
    grid-column:1/3;
    grid-row:2/3;
    display:grid;
    column-gap:1rem;
    grid-template-columns: 1fr 1fr;
  }

  .centered{
    padding-left:14rem;
    padding-right:12rem;
  }

  .centered-message{
    grid-column: 1/3;
  }

  .features{
    min-height:12rem;
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    /* padding-left:1rem; */

    
  }

  .card-header{
    display: grid;
    grid-template-columns: auto 1fr;
  }

  .card-header-content{
    grid-column: 2/3;
  }

  .feature-items{
    grid-column: 2/3;
    margin-top: 0.8rem;
    justify-self: center;
  }
  
  .feature-info{
    margin-bottom:0.6rem;
 
    
  }

 
    .adjustment{
        margin-top: 1.8rem!important;
   }

   .package-name{
    text-align: center;
    font-family: var( --heading-font2-regular);
    color:var(--page-header);
   }

   .package{
    display: grid;
    grid-template-rows:repeat(4,auto);
    
   }

   .price{
    font-size: 2rem;
    justify-self: center;
   }

   .purchase{
    background: var(--purchase);
    color: var(--purchase-text);
    font-family:var(--heading-font-regular);
    /* text-transform:uppercase; */
   }

   .figure{
    font-family: var(--heading-font-regular);
    letter-spacing:-0.1rem;
   }

   .per{
    margin-top: -0.6rem;
    font-size:0.7rem;
    font-family: var(--heading-font-regular);
    color:var(--page-header);
    /* text-align: left; */
   }

   .theme-card{
        border-radius:12px;
        margin:0rem;
        background: url('../assets/images/vocation-icon-secondary.svg') no-repeat  , var(--intro-background);
    }


    .billing-page{
       /* background-color: var(--info-page-background); */
      margin-left: 0rem;
      margin-right: 0rem;
      margin-bottom: -2rem;

      display: grid;
    }

    .card-list, .notice, .verify{
      margin:0rem 4rem;
    }

    @media(max-width: 768px) {

 .card-list{
    grid-column:1/3;
    grid-row:2/3;
    row-gap:1rem;
    display:flex;
    flex-direction: column;
  }

  

       .centered{
      padding-left:0rem;
      padding-right:0rem;
    }

    .billing{
    display: flex;
    flex-direction: column;
    }

     .features{
    min-height:14rem;
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    /* padding-left:1rem; */   
  }


     .card-list, .notice, .verify{
      margin:0rem 1rem;
    }


    }

</style>